import { useEffect, useState } from "react";
import { SvgAdd, SvgLogo, SvgRemove } from "ui/svgs";
import type { PresetType } from "ui/preset/service";
import usePresetRtcService from "ui/preset/service";
import { CameraType } from "webrtc-player/common/base";

const PresetItem = ({
  homePreset,
  data,
  selectedCamera,
  onDelete,
  onPos,
  onSet,
}: {
  homePreset?: boolean;
  selectedCamera;
  data?: PresetType;
  onDelete?: () => void;
  onPos?: () => void;
  onSet?: () => void;
}) => {
  const { getPresetSnapShotWithDbCache } = usePresetRtcService();

  const [indexDBBlobSrc, setIndexDBBlobSrc] = useState<string>();

  useEffect(() => {
    if (!data || !selectedCamera) {
      return;
    }
    const camera: CameraType = {
      id: +selectedCamera.cameraId,
      macAddress: selectedCamera.cameraMac,
      remoteIndex: +selectedCamera.remoteIndex,
    };
    getPresetSnapShotWithDbCache(
      +selectedCamera.orgId,
      +selectedCamera.nvrId,
      selectedCamera?.devId,
      camera,
      data?.id,
      data?.modifiedAt.toString(),
    ).then(async (blob) => {
      setIndexDBBlobSrc(URL.createObjectURL(blob));
    });
  }, [data, selectedCamera]);

  return (
    <button
      onClick={() => {
        if (data) {
          onPos();
        } else {
          onSet();
        }
      }}
      className="w-full h-full disabled:opacity-40 flex relative rounded-lg bg-gray-100 items-center justify-center group hover:fill-neutral-400 fill-neutral-500 "
      //style={style}
    >
      {data ? (
        <>
          <div className="w-full aspect-video object-cover rounded-lg overflow-hidden reltative">
            {indexDBBlobSrc ? (
              <img
                src={indexDBBlobSrc}
                alt="Camera Placeholder"
                className="aspect-video"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <SvgLogo width="28" className="fill-zinc-400 mb-3" />
              </div>
            )}
            <div
              className="w-[22px] h-[22px] 3xl:w-[32px] 3xl:h-[32px] rounded-full flex items-center justify-center absolute top-2 right-2 invisible group-hover:visible bg-neutral-800 fill-white hover:fill-neutral-200 bg-opacity-70"
              onClick={(e) => {
                onDelete();
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <SvgRemove width="16" />
            </div>
          </div>
          {homePreset ? (
            <p className="absolute bottom-1 left-0.5 rounded-md px-1 py-0 text-sm text-center text-[#3E83F6] bg-[#DCE7FD]">
              Home Preset
            </p>
          ) : (
            <p className="absolute bottom-1 left-0.5 rounded-md px-1 py-0 text-sm text-center text-white bg-neutral-800 bg-opacity-75">
              {data?.name}
            </p>
          )}
        </>
      ) : (
        <div>
          <SvgAdd width="18" className="" />
        </div>
      )}
    </button>
  );
};

export default PresetItem;
